<template>
  <div>
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>奖励配置管理</el-breadcrumb-item>
    </el-breadcrumb>
    <!-- 搜索筛选 -->
    <el-form :inline="true" class="user-search">
      <el-form-item>
        <el-button
          size="small"
          type="primary"
          icon="el-icon-plus"
          @click="handleEdit()"
          >添加</el-button
        >
      </el-form-item>
    </el-form>
    <!--列表-->
    <el-table
      size="small"
      :data="listData"
      highlight-current-row
      v-loading="loading"
      border
      element-loading-text="拼命加载中"
      style="width: 100%"
    >
      <el-table-column prop="id" label="配置ID"> </el-table-column>
      <el-table-column prop="thresholdDays" label="连续签到/次"> </el-table-column>
      <el-table-column prop="rewardPoints" label="奖励积分"> </el-table-column>
      </el-table-column>
      <el-table-column align="center" label="操作" width="300">
        <template slot-scope="scope">
          <el-button
            size="mini"
            type="danger"
            @click="deleteUser(scope.$index)"
            >删除</el-button
          >
        </template>
      </el-table-column>
    </el-table>
    <!-- 编辑界面 -->
    <el-dialog
      :title="title"
      :visible.sync="editFormVisible"
      width="30%"
      @click="closeDialog"
    >
      <el-form
        label-width="120px"
        :model="editForm"
        :rules="rules"
        ref="editForm"
      >
        <el-form-item label="连续签到次数" prop="thresholdDays">
          <el-input
            size="small"
            type="number"
            v-model="editForm.thresholdDays"
            auto-complete="off"
            placeholder="请输入连续签到次数"
          ></el-input>
        </el-form-item>

        <el-form-item label="奖励积分" prop="rewardPoints">
          <el-input
            size="small"
             type="number"
            v-model="editForm.rewardPoints"
            auto-complete="off"
            placeholder="请输入奖励积分"
          ></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="closeDialog">取消</el-button>
        <el-button
          size="small"
          type="primary"
          :loading="loading"
          class="title"
          @click="submitForm('editForm')"
          >保存</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  data() {
    return {
      loading: false, //是显示加载
      editFormVisible: false, //控制编辑页面显示与隐藏
      title: "添加",
      editForm: {
        rewardPoints: "",
        thresholdDays: "",
      },
      // rules表单验证
      rules: {
        rewardPoints: [
          { required: true, message: "请输入奖励积分", trigger: "blur" },
        ],
        thresholdDays: [
          { required: true, message: "请输入连续签到次数", trigger: "blur" },
        ],
      },
      listData: [], //用户数据
    };
  },
  /**
   * 创建完毕
   */
  created() {
    this.getdata();
  },

  /**
   * 里面的方法只有被调用才会执行
   */
  methods: {
    // 获取公司列表
    getdata() {
      this.loading = true;
      this.$request
        .getConfig()
        .then((res) => {
          this.loading = false;
          this.listData = res.data;
        })
        .catch((err) => {
          this.loading = false;
        });
    },
    //显示编辑界面
    handleEdit: function (index, row) {
      this.editFormVisible = true;
      this.title = "添加";
      this.editForm.thresholdDays = "";
      this.editForm.rewardPoints = "";
    },
    // 编辑、增加页面保存方法
    submitForm(editData) {
      this.$refs[editData].validate((valid) => {
        if (valid) {
          this.loading = true;
          this.listData.push(this.editForm);
          this.$request
            .postConfig({
              configs: this.listData,
            })
            .then((res) => {
              this.loading = false;
              this.editFormVisible = false;
              this.getdata();
            })
            .catch((err) => {
              this.loading = false;
            });
        } else {
          return false;
        }
      });
    },
    // 删除公司
    deleteUser(index) {
      this.$confirm("确定要删除吗?", "信息", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.loading = true;
          this.$request
            .deleteConfig({
              id: this.listData[index].id,
            })
            .then((res) => {
              this.loading = false;
              this.editFormVisible = false;
              this.getdata();
            })
            .catch((err) => {
              this.loading = false;
            });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
    // 关闭编辑、增加弹出框
    closeDialog() {
      this.editFormVisible = false;
    },
  },
};
</script>

<style scoped>
.user-search {
  margin-top: 20px;
}
.userRole {
  width: 100%;
}
</style>

 
 


// WEBPACK FOOTER //
// src/views/configs/configs.vue